import { render, staticRenderFns } from "./RoleLinkedModal.vue?vue&type=template&id=041c15ef&scoped=true&"
import script from "./RoleLinkedModal.vue?vue&type=script&lang=js&"
export * from "./RoleLinkedModal.vue?vue&type=script&lang=js&"
import style0 from "./RoleLinkedModal.vue?vue&type=style&index=0&id=041c15ef&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "041c15ef",
  null
  
)

export default component.exports